import { unitsPredicta } from './units';
const units = unitsPredicta.unidades;

const unitsPredictaByUF: any = (() => {
  let result: any = [];

  // Cria o objeto com UF e o objeto unidades vazio
  Object.keys(units).forEach((key: any) => {
    result.push({ uf: units[key].uf, units: [] });
  });

  // Remove UFs duplicadas
  result = result.filter(function (this: typeof result, a: any) {
    return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
  }, Object.create(null));

  // Insere as unidades no seu respectivo estado
  Object.keys(units).forEach((key: any) => {
    const index = result.findIndex((index: any) => index.uf === units[key].uf);
    // Desconsidera a unidade ambulatorial do ibirapuera
    if (units[key].id !== 72) {
      result[index].units.push('Unidade ' + units[key].name);
    }
  });

  // Ordena as unidades
  Object.keys(result).forEach((key: any) => {
    result[key].units.sort();
  });

  return result;
})();

export default unitsPredictaByUF;
